import type { FC, PropsWithChildren } from "react";
import React, { useMemo } from "react";
import { cx } from "@emotion/css";
import type { ButtonProps as NutuiButtonProps } from "@nutui/nutui-react";
import { Button as NutuiButton } from "@nutui/nutui-react";
import "./button.css";

export interface ButtonProps
  extends Partial<
    Pick<NutuiButtonProps, "type" | "size" | "fill" | "disabled" | "loading" | "shape" | "nativeType">
  > {
  /**
   * What background color to use
   */
  color?: string;
  /**
   * Button contents
   */
  className?: string;
  /**
   * Optional click handler
   */
  onClick?: () => void;
}

/**
 * Primary UI component for user interaction
 */
export const Button: FC<PropsWithChildren<ButtonProps>> = ({
  size = "large",
  type = "primary",
  className,
  children,
  disabled,
  shape = "square",
  ...props
}) => {
  const buttonColor = useMemo(() => {
    switch (type) {
      case "primary":
        return "#00AFCC";
      default:
        return "";
    }
  }, [type]);
  return (
    <NutuiButton
      size={size}
      shape={shape}
      className={cx({ "!rounded-md": shape === "square" }, className)}
      type={disabled ? "info" : type}
      disabled={disabled}
      color={buttonColor}
      {...props}
    >
      {children}
    </NutuiButton>
  );
};
